__turbopack_context__.v({
  "layout": "ProductSpotlight-module__O8UFqa__layout",
  "panels": "ProductSpotlight-module__O8UFqa__panels",
  "railSlot": "ProductSpotlight-module__O8UFqa__railSlot",
  "root": "ProductSpotlight-module__O8UFqa__root",
});
